export enum QuoteStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected"
}
